import Samples from "./samples.js";
import PatternList from "./patternList.js";

class Loader {
    constructor() {
        this.data = {};
    }

    async start() {

        // Load static resources
        await this.loadStaticFiles();

        // DB call simulation
        await this.dbCall();
    }

    // Simulated DB call
    async dbCall() {
        // Code that executes a database call
    }


    async loadStaticFiles() {
        this.data.samples = Samples();
        this.data.patterns = PatternList();
        this.data.columns = this.getColumns(this.data.patterns);
        this.data.tracks = this.createTracks(this.data.patterns, this.data.samples);
        this.data.rows = this.data.tracks.size;
        this.data.titles = this.createTitleList(this.data.patterns, this.data.samples);
        this.data.matrix = this.createMatrix(this.data.patterns, this.data.columns);
        this.data.patternMatrix = this.createPatternMatrix(this.data.patterns, this.data.tracks.size);
    }

    // ... getter functions as before

    getColumns(patternList) {
        return patternList[0].noteCount;
    }

    createTracks(patternList, samples) {
        const tracks = new Map();
        const patterns = patternList[0].patternList;
        patterns.forEach((pattern) => {
            const sampleKey = pattern.sample;
            if (samples.hasOwnProperty(sampleKey)) {
                tracks.set(sampleKey, samples[sampleKey].file);
            }
        });
        return tracks;
    }

    createTitleList(patternList, samples) {
        const titles = new Map();
        const patterns = patternList[0].patternList;
        patterns.forEach((pattern) => {
            const sampleKey = pattern.sample;
            if (samples.hasOwnProperty(sampleKey)) {
                titles.set(sampleKey, samples[sampleKey].name);
            }
        });
        return titles;
    }

    createMatrix(patternList, columns) {
        let sequenceList = patternList[0].patternList;
        const matrix = new Map();
        sequenceList.forEach((pattern) => {
            let columnNotes = new Array(columns).fill(false);
            pattern.notes[0].forEach(noteIndex => {
                if (noteIndex < columns) {
                    columnNotes[noteIndex] = true;
                }
            });
            matrix.set(pattern.sample, columnNotes);
        });
        return matrix;
    }

    createPatternMatrix(patternList, rows) {
        let sequenceList = patternList[0].patternList;
        const matrix = new Map();
        sequenceList.forEach((pattern) => {
            let rowNotes = new Array(rows).fill([]);
            rowNotes = pattern.notes;
            matrix.set(pattern.sample, rowNotes);
        });
        return matrix;
    }
}

export default Loader;
